// Shared constants for the PLSCADD KMZ Ingress tabs.

export const PLSCADD_KMZ_DATASET_TYPE = "plscadd-kmz";
export const PLSCADD_KMZ_CONFIGS_DATASET_TYPE = "plscadd-kmz-process-configs";
export const PLSCADD_KMZ_REPORT_DATASET_TYPE = "plscadd-kmz-process-report";
export const ROOT_GEOJSON_DATASET_TYPE = "root-geojson";
export const DEFAULT_GROUP_KEY = "default";
export const GOOGLE_DRIVE_SCOPE = "https://www.googleapis.com/auth/drive.readonly";
